import {getPrivateAxios} from '../../libs';

export interface FeedbackCreateDto {
  message: string;
}

/**
 * Create feedback
 * @returns
 */
export const fetchFeedbackCreate = async (dto: FeedbackCreateDto) => {
  const {data} = await getPrivateAxios().post('/feedback', dto);
  return data;
};
